function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "LessonMenu-icon-finish",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.000000, 10.000000)",
  fill: "#FFF700",
  fillRule: "nonzero",
  id: "Combined-Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25,0 C31.6304122,0 37.9892601,2.63392101 42.6776695,7.32233047 C47.366079,12.0107399 50,18.3695878 50,25 C50,38.8071187 38.8071187,50 25,50 C11.1928813,50 0,38.8071187 0,25 C0,11.1928813 11.1928813,0 25,0 Z M38.4597194,12 C37.5205529,12 36.6199778,12.3731933 35.9566918,13.0372405 L20.5050957,28.4691332 L14.0429239,22.0021239 C13.1486782,21.1090186 11.8452868,20.7602213 10.6237245,21.0871205 C9.40216228,21.4140197 8.44801354,22.3669518 8.12069692,23.5869563 C7.79338029,24.8069609 8.14262297,26.1086903 9.03686862,27.0017956 L17.9712958,35.9287531 L18.0040322,35.9614478 C18.667423,36.6262972 19.56856,37 20.5083693,37 C21.4481786,37 22.3493156,36.6262972 23.0127064,35.9614478 L40.9627471,18.0342966 C41.6268398,17.3719617 42,16.4730959 42,15.5357686 C42,14.5984412 41.6268398,13.6995754 40.9627471,13.0372405 C40.2994611,12.3731933 39.398886,12 38.4597194,12 Z"
})));
function SvgLessonMenuIconFinish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LessonMenu-icon-finish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonMenuIconFinish);
export default __webpack_public_path__ + "static/media/LessonMenu-icon-finish.eec19ad08c09b06e4e23168bfa71a3a4.svg";
export { ForwardRef as ReactComponent };